import { render, staticRenderFns } from "./PenindakanAppUM.vue?vue&type=template&id=f4489806&scoped=true&"
import script from "./PenindakanAppUM.vue?vue&type=script&lang=js&"
export * from "./PenindakanAppUM.vue?vue&type=script&lang=js&"
import style0 from "./PenindakanAppUM.vue?vue&type=style&index=0&id=f4489806&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4489806",
  null
  
)

export default component.exports